export default {
    testApi: () => {
        console.log('api called');
        return {
            example: 'covdrtyfujentry',
        };
    },
};
